<app-rc-dialog-wrapper noClose="true">
  <div class="content__header">
    <div class="rc-title-delta header__title">
      <ng-container i18n="@@msg__selected">You have selected</ng-container>
      {{ selectedProducts.length }}
      <ng-container i18n="@@title_products">{{ 'product(s)' | lowercase }}</ng-container>
    </div>
    <p class="rc-paragraph header__paragraph" i18n="@@starter-kit__popin__add-other-products">
      Do you want to add other products or continue to your order?
    </p>
  </div>

  <div class="content__products">
    @if (selectedProducts.length > 0) {
      <div class="product-cart__content product-cart__content--list-vertical">
        @for (product of selectedProducts; track product.id) {
          <div class="product-cart__item product-cart__item--list-vertical">
            <!-- Product Cart : Product thumb -->
            <img [alt]="product.name || ''" [src]="product.image | publicUrl: product.productType" class="product-cart__item-thumb image" />
            <!-- Product Cart : Description -->
            <div class="product-cart__description">
              <p class="rc-paragraph type">
                {{ product.productType | translationCode: LocaleContentEnum.ProductType }}
              </p>
              <h6 class="rc-paragraph product-cart__item-name name">
                {{ product.name || '' | titlecase }}
              </h6>
            </div>
            <!-- Product Cart : Remove Item -->
            <rc-button
              data-qa="vs-selected-products-popin-button-cancel"
              variant="tertiary"
              size="medium"
              type="button"
              iconname="feedback-failure-alt"
              rounded="true"
              (click)="removeItem(product)"
              class="product-cart__item-remove"
            ></rc-button>
          </div>
        }
      </div>
    }
  </div>

  <div class="content__footer">
    <div class="rc-dialog-form__action">
      <rc-link data-qa="vs-selected-products-popin-button-add-products" variant="secondary" size="large" (click)="closeAndAddProducts()">
        {{ 'starter-kit__popin__add-products' | translateKey | titlecase }}
      </rc-link>
      <span class="rc-button__separator" i18n="@@action_separator">or</span>
      <rc-button data-qa="vs-selected-products-popin-button-continue" (click)="continue()">
        {{ 'action_continue' | translateKey | titlecase }}
      </rc-button>
    </div>
  </div>
</app-rc-dialog-wrapper>
